export const Vendor = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3483_1532)">
        <path
          d="M6.5 8C8.1545 8 9.5 6.6545 9.5 5C9.5 3.3455 8.1545 2 6.5 2C4.8455 2 3.5 3.3455 3.5 5C3.5 6.6545 4.8455 8 6.5 8ZM6.5 3C7.603 3 8.5 3.897 8.5 5C8.5 6.103 7.603 7 6.5 7C5.397 7 4.5 6.103 4.5 5C4.5 3.897 5.397 3 6.5 3ZM12.5 11.5H13.5V14H8V11.5H9V13H12.5V11.5ZM4.5 9H6.846L6.3845 10H4.5C3.673 10 3 10.673 3 11.5V14H2V11.5C2 10.1215 3.1215 9 4.5 9ZM14 10C14 10.5525 13.5845 11 13.0715 11H12.762C12.249 11 11.8335 10.5525 11.8335 10C11.8335 10.5525 11.418 11 10.905 11H10.5955C10.0825 11 9.667 10.5525 9.667 10C9.667 10.5525 9.2515 11 8.7385 11H8.429C7.916 11 7.5005 10.5525 7.5005 10L8.1195 8.5H13.3815L14 10Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_3483_1532">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
